import { RefObject } from 'react';

import useEventListener from './useEventListener';

type Handler = (event: MouseEvent) => void;

const MOUSE_EVENT_NAME = 'mousedown';
const ANT_MODAL_CLASS_NAME = 'ant-modal';
const DEFAULT_IGNORED_CLASSES: string[] = [
  'ant-dropdown',
  'ant-select-dropdown',
  'ant-picker-dropdown'
];

const hasSomeParentTheClass = (
  element: Element | null,
  classNames: string[]
): boolean => {
  if (!element) return false;

  const isContainClassNames = classNames.some((className) =>
    element.classList?.contains(className)
  );

  if (isContainClassNames) return true;

  return hasSomeParentTheClass(element.parentElement, classNames);
};

const useHandleOutsideClick = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: Handler,
  active: boolean,
  additionalIgnoredClasses: string[] = []
): void => {
  const ignoredClasses = [
    ...DEFAULT_IGNORED_CLASSES,
    ...additionalIgnoredClasses
  ];

  useEventListener(
    MOUSE_EVENT_NAME,
    (event) => {
      const el = ref?.current;
      const target = event.target;

      if (!(target instanceof Node)) return;

      const isModalOpen = Boolean(
        window.document.getElementsByClassName(ANT_MODAL_CLASS_NAME).length
      );

      const isFromIgnoredElement = hasSomeParentTheClass(
        target instanceof Element ? target : null,
        ignoredClasses
      );

      if (!el || el.contains(target) || isModalOpen || isFromIgnoredElement) {
        return;
      }

      handler(event as MouseEvent);
    },
    active
  );
};

export default useHandleOutsideClick;
